import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "elvosh_cart";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(KEY)) || [];
        } catch {
            return [];
        }
    });
    const [direct, setDirect] = useState(null);

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    const add = useCallback((product, qty = 1) => {
        setItems((prev) => {
            const idx = prev.findIndex((i) => i.product_id === product.id);
            const image = product.images?.[0]?.url || "";
            const snap = { name: product.name, price: product.price, mrp: product.mrp, image, slug: product.slug, stock: product.stock };
            if (idx >= 0) {
                const copy = [...prev];
                const newQty = Math.min(copy[idx].qty + qty, product.stock);
                copy[idx] = { ...copy[idx], qty: newQty, snap };
                return copy;
            }
            return [...prev, { product_id: product.id, qty: Math.min(qty, product.stock), snap }];
        });
    }, []);

    const updateQty = useCallback((product_id, qty) => {
        setItems((prev) =>
            prev.map((i) => (i.product_id === product_id ? { ...i, qty: Math.max(1, Math.min(qty, i.snap.stock || 99)) } : i))
        );
    }, []);

    const remove = useCallback((product_id) => {
        setItems((prev) => prev.filter((i) => i.product_id !== product_id));
    }, []);

    const clear = useCallback(() => setItems([]), []);

    const buyNow = useCallback((product, qty = 1) => {
        const image = product.images?.[0]?.url || "";
        setDirect({
            product_id: product.id,
            qty: Math.min(qty, product.stock),
            snap: { name: product.name, price: product.price, mrp: product.mrp, image, slug: product.slug, stock: product.stock },
        });
    }, []);

    const clearDirect = useCallback(() => setDirect(null), []);

    const count = items.reduce((a, i) => a + i.qty, 0);
    const subtotal = items.reduce((a, i) => a + i.snap.price * i.qty, 0);

    return (
        <CartContext.Provider
            value={{ items, add, updateQty, remove, clear, count, subtotal, direct, buyNow, clearDirect }}
        >
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
